import { render } from "./MailLog.vue?vue&type=template&id=cf96d34a&scoped=true&ts=true"
import script from "./MailLog.vue?vue&type=script&lang=ts"
export * from "./MailLog.vue?vue&type=script&lang=ts"

import "./MailLog.vue?vue&type=style&index=0&id=cf96d34a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf96d34a"]])

export default __exports__